import * as types from "./atividade.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";
import store from "@common/store/store";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  atividades: [],
  Atividade: undefined,
  parameters: {
    cnaesVinculados: [],
  },
  changeState: undefined,
});

const reduce = (state = initialState, action = {}) => {
  let payload = action.payload === undefined ? {} : action.payload;
  switch (action.type) {
    case types.SET_ATIVIDADE:
      return state.merge({ atividades: payload });
    case types.ADD_ATIVIDADE:
      return state.merge({
        atividades: [...state.atividades, payload],
        SuggestionAtividade: undefined,
      });
    case types.MAIN_ATIVIDADE:
      return state.merge({
        atividades: state.atividades.map((x) =>
          x.IdAtividade == payload.IdAtividade
            ? { ...x, Principal: 1 }
            : { ...x, Principal: 0 }
        ),
      });
    case types.DELETE_ATIVIDADE:
      return state.merge({ atividades: payload });
    case types.CLEAR_GRID_ATIVIDADE:
      return state.merge({ atividades: [] });
    case types.REDUCER_ATIVIDADE_REMOVER_BY_CNAE:
      return state.merge({ atividades: payload });
    case types.ON_CHANGE_ATIVIDADE:
      return state.merge({ SuggestionAtividade: [...payload] });
    case commonActionType.RESET:
      return initialState;
    default:
      return state;
  }
};

store.registerDynamicModule("atividade", reduce);
